;(function module() {
  angular.module('app.ui.form.ctrls').controller('ForgotPasswordController', [
    'logger',
    'ForgetPasswordApi',
    '$scope',
    function controller(logger, ForgetPasswordApi, $scope) {
      let vm = this
      vm.userEmail = ''
      vm.btnLabel = 'Continue'
      vm.notify = (type, message) => {
        switch (type) {
          case 'info':
            logger.log(
              "Heads up! This alert needs your attention, but it's not super important."
            )
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(
              "Warning! Best check yo self, you're not looking too good."
            )
            break
          case 'error':
            logger.logError(message)
            break
          default:
            break
        }
      }

      vm.showClass = ''
      vm.hideDropDown = () => {
        vm.showClass = ''
      }

      vm.showDropDown = () => {
        if (vm.showClass === '') vm.showClass = 'show'
        else vm.showClass = ''
      }

      vm.linkRequested = false
      vm.sendLink = async () => {
        try {
          const {status} = await ForgetPasswordApi.changePassword({
            email: vm.userEmail,
          })
          if (status === 201) {
            vm.btnLabel = 'Sent'
            const message =
              'A link has been emailed to you. Please check your inbox and junk folder and follow the given instructions to reset your password.'
            vm.notify('success', message)
            vm.linkRequested = true
            $scope.$apply()
          }
        } catch (error) {
          vm.notify('error', error.data.message)
        }
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/forgot-password/forgot-password.ctrl.js